import { SystemLanguageEnum } from "~/types/const";
import { useRuntimeConfig } from '#app'
import fs from 'fs';
import path from 'path';
import { localStorageLanguageCache } from './localStorageCache';
import { LanguageApi } from '~/services/api';
import { ConfigApi } from '~/services/api';
const serverCodeMap = {
    [SystemLanguageEnum.ZH]: 'zh-cn',
    [SystemLanguageEnum.ZH_TW]:"zh-tw",
    [SystemLanguageEnum.EN]:'en',
    [SystemLanguageEnum.AR]:'ar',
    [SystemLanguageEnum.FR]:'fr',
    [SystemLanguageEnum.DE]:'de',
    [SystemLanguageEnum.JA]:'ja',
    [SystemLanguageEnum.KO]:'ko',
    [SystemLanguageEnum.HI]:'hi',
    [SystemLanguageEnum.ID]:'id',
    [SystemLanguageEnum.ITB]:'itb',
    [SystemLanguageEnum.UK]:'uk',
}
export default serverCodeMap;


export async function getServerLanguageBySave(locale: string, json: any) {
    let oldJson = {
        ...json
    }
    
    if (import.meta.server) {
        // // 服务端渲染：检查localStorage缓存
        // const cached = localStorageLanguageCache.getLanguageCache(locale);
        // if (cached) {
        //     console.log(`Using localStorage cached language data for ${locale}, version: ${cached.version}`);
        //     return cached.data;
        // }

        // 获取本地版本号（仅在开发环境）
        let localVersion = '';
        const cached = localStorageLanguageCache.getLanguageCache(locale);
        if (cached) {
            console.log(`Using localStorage cached language data for ${locale}, version: ${cached.version}`);
            localVersion = cached.version;
        }
        // try {
        //     const rootDir = process.cwd().includes('.output') 
        //         ? path.resolve(process.cwd(), '..') 
        //         : process.cwd();
        //     const versionPath = path.resolve(rootDir, 'i18n', 'json/version.json');
        //     const versionJson = await fs.readFileSync(versionPath, 'utf8');
        //     const zh_version = JSON.parse(versionJson);
        //     localVersion = zh_version['version'];
        // } catch (error) {
        //     console.log('Could not read local version file, using empty version');
        // }

        // 请求服务器版本信息
        let res_version: any;
        try {
            res_version = await $fetch(`https://api.test.pdf1.com${ConfigApi.getHomePageConfig}`, {
                method: 'GET',
                headers: {
                    'accept': "application/json",
                    'Content-Type': "application/json",
                    'deviceId': "3daf2da89e176c59aebb1034ffd5d656",
                    'internationalCode': locale,
                    'clientType': "web",
                    'appSource': "pdfOne",
                },
            });
        } catch (error) {
            console.error('Failed to fetch version from server:', error);
            return oldJson;
        }

        if (res_version.code === '1') {
            const serverVersion = res_version.data.multiLangVersionByBiz;
            console.log(`Version check - Local: ${localVersion}, Server: ${serverVersion}, Locale: ${locale}`);
            
            // 检查是否需要更新（版本不一致或缓存不存在）
            if (localVersion !== serverVersion) {
                try {
                    const res: any = await $fetch(`https://api.test.pdf1.com${LanguageApi.getLanguageConfig}`, {
                        method: 'GET',
                        headers: {
                            'accept': "application/json",
                            'Content-Type': "application/json",
                            'deviceId': "3daf2da89e176c59aebb1034ffd5d656",
                            'internationalCode': locale,
                            'clientType': "web",
                            'appSource': "pdfOne",
                        }
                    });

                    if (res.code === '1') {
                        const { chineseStr, englishStr, japaneseStr, chineseTwStr, koreanStr, versionNo, hindiStr, arStr, deStr, frStr, idStr, itbStr, ukStr } = res.data;
                        
                        // 根据语言类型解析并缓存到localStorage
                        const languageMap: { [key: string]: string } = {
                            'zh-cn': chineseStr,
                            'en': englishStr,
                            'ja': japaneseStr,
                            'zh-tw': chineseTwStr,
                            'ko': koreanStr,
                            'hi': hindiStr,
                            'ar': arStr,
                            'de': deStr,
                            'fr': frStr,
                            'id': idStr,
                            'itb': itbStr,
                            'uk': ukStr
                        };

                        // 缓存所有语言数据到localStorage
                        Object.entries(languageMap).forEach(([langCode, langStr]) => {
                            if (langStr) {
                                try {
                                    const newJson = JSON.parse(langStr);
                                    localStorageLanguageCache.setLanguageCache(langCode, newJson, versionNo);
                                    
                                    // 如果是当前请求的语言，更新返回值
                                    if (langCode === locale) {
                                        oldJson = newJson;
                                    }
                                } catch (parseError) {
                                    console.error(`Failed to parse language data for ${langCode}:`, parseError);
                                }
                            }
                        });

                        // 设置全局版本号
                        localStorageLanguageCache.setGlobalVersion(versionNo);
                        console.log(`Successfully updated localStorage language cache for ${locale}, version: ${versionNo}`);
                    }
                } catch (error) {
                    console.error('Failed to fetch language config from server:', error);
                }
            } else {
                const cached = localStorageLanguageCache.getLanguageCache(locale);
                if (cached) {
                    return cached.data;
                }
            }
        }
    }
    
    return oldJson;
}

export async function getLocalLanguageBySave(json: any, locale: string) {
    let oldJson = {
        ...json
    }
    let localVersion = localStorage.getItem(`lang_version`);
    
    // 请求服务器版本信息
    let res_version: any;
    try {
        res_version = await $fetch(`${useRuntimeConfig().public.apiUrl}${ConfigApi.getHomePageConfig}`, {
            method: 'GET',
            headers: {
                'accept': "application/json",
                'Content-Type': "application/json",
                'deviceId': "3daf2da89e176c59aebb1034ffd5d656",
                'internationalCode': locale,
                'clientType': "web",
                'appSource': "pdfOne",
            },
        });
    } catch (error) {
        console.error('Failed to fetch version from server:', error);
        return oldJson;
    }

    if (res_version.code === '1') {
        const serverVersion = res_version.data.multiLangVersionByBiz;
        console.log(`Version check - Local: ${localVersion}, Server: ${serverVersion}, Locale: ${locale}`);
        
        // 检查是否需要更新（版本不一致或缓存不存在）
        if (localVersion !== serverVersion) {
            try {
                const res: any = await $fetch(`${useRuntimeConfig().public.apiUrl}${LanguageApi.getLanguageConfig}`, {
                    method: 'GET',
                    headers: {
                        'accept': "application/json",
                        'Content-Type': "application/json",
                        'deviceId': "3daf2da89e176c59aebb1034ffd5d656",
                        'internationalCode': locale,
                        'clientType': "web",
                        'appSource': "pdfOne",
                    }
                });

                if (res.code === '1') {
                    const { chineseStr, englishStr, japaneseStr, chineseTwStr, koreanStr, versionNo, hindiStr, arStr, deStr, frStr, idStr, itbStr, ukStr } = res.data;
                    
                    // 根据语言类型解析并缓存到localStorage
                    const languageMap: { [key: string]: string } = {
                        'zh-cn': chineseStr,
                        'en': englishStr,
                        'ja': japaneseStr,
                        'zh-tw': chineseTwStr,
                        'ko': koreanStr,
                        'hi': hindiStr,
                        'ar': arStr,
                        'de': deStr,
                        'fr': frStr,
                        'id': idStr,
                        'itb': itbStr,
                        'uk': ukStr
                    };

                    // 缓存所有语言数据到localStorage
                    Object.entries(languageMap).forEach(([langCode, langStr]) => {
                        if (langStr) {
                            try {
                                const newJson = JSON.parse(langStr);
                                localStorage.setItem(`lang_${langCode}`, JSON.stringify(newJson));

                                
                                // 如果是当前请求的语言，更新返回值
                                if (langCode === locale) {
                                    oldJson = newJson;
                                }
                            } catch (parseError) {
                                console.error(`Failed to parse language data for ${langCode}:`, parseError);
                            }
                        }
                    });
                    // 设置全局版本号
                    localStorage.setItem(`lang_version`, versionNo);
                    console.log(`Successfully updated localStorage language cache for ${locale}, version: ${versionNo}`);
                }
            } catch (error) {
                console.error('Failed to fetch language config from server:', error);
            }
        } else {
            console.log(`Language data is up to date for ${locale}`);
        }
    }
    return oldJson
}